import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getSelectBillingPlanPath = () => {
  return urlHelper(`/checkout/select-billing-plan`);
};
